<template>
    <wizard-panel name="competences" :status="panels.competences">
        <div class="wizard-panel__inner" v-if="panels.competences === 1">
            <div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
                <tabs>
                    <tab title="Soft Skills">
                        <button v-if="!read" type="button" class="btn btn_action-second btn_full" @click.stop="openSkills('softSkills')">
                            Создать или найти Soft Skill

                            <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                        </button>

                        <accordion class="mt-12">
                            <accordion-item ref="softSkills" v-for="(item, index) in softSkills" :key="item.id" :bus="bus" :active="true">
                                <template #accordion-head>
                                    <div tabindex="0" class="accordion__head">
                                        <div class="accordion__head-item">
                                            <p class="accordion__title" v-html="item.name"></p>
                                        </div>

                                        <div class="accordion__head-item">
                                            <selector-btn v-if="!read" class="ml-12" :options="accordionSoftdSkillsOptionsForBtn" :params="{'id': item.id, 'item': item }" :inAccordion="true" @clickOnItem="callback"></selector-btn>

                                            <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                                <icon-arrow-down />
                                            </icon-base>
                                        </div>
                                    </div>
                                </template>

                                <div class="accordion__content">
                                    <div class="competence">
                                        <header class="competence__head">
                                            <div class="competence__head-inner">
                                                <div class="competence__head-item">
                                                    <h2 class="competence__title">Дескрипторы компетенции</h2>
                                                </div>
                                                <div class="competence__head-item" v-if="!editDescriptors[item.id]">
                                                    <button v-if="!read" type="button" class="change-btn" @click.stop="toggleEditMode(item.id)">
                                                        Редактировать

                                                        <icon-base viewBox="0 0 18 18" class="change-btn__icon"><icon-edit /></icon-base>    
                                                    </button>
                                                </div>
                                                <div class="competence__head-item" v-else>
                                                    <button type="button" class="btn btn_success btn_small" @click.stop="updateSoftSkill(item)">
                                                        Сохранить

                                                        <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon"><icon-save /></icon-base>
                                                    </button>
                                                </div>
                                            </div>
                                        </header>
                                    
                                        <quill-editor v-model="item.competency_descriptor" v-if="editDescriptors[item.id]" />
                                        <div class="competence__content" v-else>
                                          <div v-html="item.competency_descriptor"></div>
                                        </div>
                                    </div>

                                    <!-- <div class="competence">
                                        <header class="competence__head">
                                            <div class="competence__head-inner">
                                                <div class="competence__head-item">
                                                    <h2 class="competence__title">Дескрипторы компетенции</h2>
                                                </div>
                                                <div class="competence__head-item">
                                                    <button type="button" class="change-btn" @click.prevent="mainInfoEditable = true">
                                                        Редактировать

                                                        <icon-base viewBox="0 0 18 18" class="change-btn__icon"><icon-edit /></icon-base>    
                                                    </button>
                                                </div>
                                            </div>
                                        </header>

                                        <h4>Полномочия и&nbsp;ответсвенность:</h4>

                                        <ul class="list">
                                            <li class="list__item">
                                                Самостоятельная деятельность по&nbsp;решению практических задач, требующих самостоятельного анализа ситуации и&nbsp;ее&nbsp;изменений
                                            </li>
                                            <li class="list__item">
                                                Участие в&nbsp;управлении решением поставленных задач в&nbsp;рамках подразделения
                                            </li>
                                            <li class="list__item">
                                                Ответственность за&nbsp;решение поставленных задач или результат деятельности группы работников
                                            </li>
                                        </ul>

                                        <h4>Характер умений:</h4>

                                        <ul class="list">
                                            <li class="list__item">
                                                Решение различных типов практических задач с&nbsp;элементами проектирования
                                            </li>
                                            <li class="list__item">
                                                Выбор способов решения в&nbsp;изменяющихся (различных) условиях рабочей ситуации
                                            </li>
                                            <li class="list__item">
                                                Текущий и&nbsp;итоговый контроль, оценка и&nbsp;коррекция деятельности
                                            </li>
                                        </ul>

                                        <h4>Характер знаний:</h4>

                                        <ul class="list">
                                            <li class="list__item">
                                                Применение профессиональных знаний технологического или методического характера
                                            </li>
                                            <li class="list__item">
                                                Самостоятельный поиск информации, необходимой для решения поставленных задач
                                            </li>
                                            <li class="list__item">
                                                Текущий и&nbsp;итоговый контроль, оценка и&nbsp;коррекция деятельности
                                            </li>
                                        </ul>
                                    </div> -->
                                </div>
                            </accordion-item>
                        </accordion>
                    </tab>
                    <tab title="Hard Skills">
                        <button v-if="!read" type="button" class="btn btn_action-second btn_full" @click.stop="openSkills('hardSkills')">
                            Создать или найти Hard Skills

                            <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                        </button>

                        <ul class="entry-list mt-12">
                            <li class="entry-list__item" v-for="item in hardSkillsByQualification" :key="item.id">
                                <div class="entry">
                                    <div class="entry__inner">
                                        <div class="entry__item" v-html="item.name"></div>
                                        <div v-if="!read" class="entry__item">
                                            <div class="entry__actions">
                                                <div class="entry__actions-item">
                                                    <button type="button" class="settings-btn">
                                                        <selector-btn :options="accordionHardSkillsOptionsForBtn" :params="{ id: item.id, item: item }" @clickOnItem="callback"></selector-btn>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </tab>
                </tabs>
            </div>
        </div>

        <div class="wizard-panel__inner" v-if="panels.competences === 2 && activeSkills === 'softSkills'">
            <div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
                <header class="panel-head">
                    <div class="badge wizard-panel__badge" v-html="kindName"></div>

                    <h2>Добавление общих компетенций</h2>

                    <form class="search-form" @submit.prevent>
                        <div class="search-form__inner">
                            <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': input && input.length !== 0 }" placeholder="Поиск" v-model.trim="input" @keydown.enter.prevent.stop>

                            <button v-if="input && input.length !== 0" class="search-form__reset" @click="input = ''">
                                <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                            </button>

                            <button class="search-form__submit" disabled>
                                <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                            </button>
                        </div>
                    </form>
                </header>

                <div class="wizard-panel__content">
                    <accordion>
                        <draggable
                            item-key="id"
                            :clone="cloneSoftSkill"
                            :move="onmoveTest"
                            :group="{
                                name: 'softSkills',
                                pull: 'clone',
                                put: false
                            }"
                            :list="Object.values(competencesData)"
                            :sort="false"
                        >
                            <accordion-item v-for="(competenceList, key) in competencesData" :key="key">
                                <template #accordion-head>
                                    <div tabindex="0" class="accordion__head">
                                        <div class="accordion__head-item">
                                            <p class="accordion__title" v-html="key"></p>
                                        </div>

                                        <div class="accordion__head-item">
                                            <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                                <icon-arrow-down />
                                            </icon-base>

                                            <span class="draggable-btn ml-24">
                                                <icon-base viewBox="0 0 10 14"><icon-draggable /></icon-base>
                                            </span>
                                        </div>
                                    </div>
                                </template>

                                <tabs class="tabs_second" @clickOnTitle="startHandler">
                                    <tab v-for="competence in competenceList" :title="`<button type='button' class='tabs__btn'>${ competence.level }</button>`" :key="competence.id">
                                        <div class="competence mt-24">
                                            <header class="competence__head">
                                                <div class="competence__head-inner">
                                                    <div class="competence__head-item">
                                                        <h2 class="competence__title">Дескрипторы компетенции</h2>
                                                    </div>
                                                </div>
                                            </header>

                                            <div class="competence__content" v-html="competence.competency_descriptor"></div>
                                        </div>
                                    </tab>
                                </tabs>
                            </accordion-item>
                        </draggable>
                    </accordion>
                </div>
            </div>
            <div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
                <h2>Добавленные общие компетенции</h2>

                <button type="button" class="btn btn_action-second btn_full" @click.stop="elDialogs.softSkills = true">
                    Создать или найти Soft Skill

                    <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                </button>

                <accordion class="mt-12">
                    <draggable
                        item-key="id"
                        handle=".handle"
                        :group="{
                            name: 'softSkills',
                            pull: false
                        }"
                        :sort="false"
                        @add="addSoftSkill"
                    >
                        <accordion-item v-for="item in softSkills" :key="item.id">
                            <template #accordion-head>
                                <div tabindex="0" class="accordion__head">
                                    <div class="accordion__head-item">
                                        <p class="accordion__title" v-html="item.name"></p>
                                    </div>

                                    <div class="accordion__head-item">
                                        <selector-btn class="ml-12" :options="accordionSoftdSkillsOptionsForBtn" :params="{ 'id': item.id, 'item': item }" :inAccordion="true" @clickOnItem="callback"></selector-btn>

                                        <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                            <icon-arrow-down />
                                        </icon-base>
                                    </div>
                                </div>
                            </template>

                            <div class="accordion__content">
                                <div class="competence">
                                    <header class="competence__head">
                                        <div class="competence__head-inner">
                                            <div class="competence__head-item">
                                                <h2 class="competence__title">Дескрипторы компетенции</h2>
                                            </div>
                                            <div class="competence__head-item" v-if="!editDescriptors[item.id]">
                                                <button type="button" class="change-btn" @click.stop="toggleEditMode(item.id)">
                                                    Редактировать

                                                    <icon-base viewBox="0 0 18 18" class="change-btn__icon"><icon-edit /></icon-base>    
                                                </button>
                                            </div>
                                            <div class="competence__head-item" v-else>
                                                <button type="button" class="btn btn_success btn_small" @click.stop="updateSoftSkill(item)">
                                                    Сохранить

                                                    <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon"><icon-save /></icon-base>
                                                </button>
                                            </div>
                                        </div>
                                    </header>

                                    <quill-editor v-model="item.competency_descriptor" v-if="editDescriptors[item.id]" />
                                    <div class="f" v-if="editDescriptors[item.id]"></div>
                                    <div class="competence__content" v-else>
                                      <div v-html="item.competency_descriptor"></div>
                                    </div>
                                </div>
                            </div>
                        </accordion-item>
                    </draggable>
                </accordion>
            </div>
        </div>

        <div class="wizard-panel__inner" v-if="panels.competences === 2 && activeSkills === 'hardSkills'">
            <div class="wizard-panel__column js-wizard-panel-column">
                <header class="panel-head">
                    <div class="badge wizard-panel__badge" v-html="kindName"></div>
                </header>

                <div class="wizard-panel__content">
                    <div>
                        <h2>Добавление Hard Skill</h2>

                        <tabs>
                            <tab title="Трудовые функции">
                                <form class="search-form mb-24" @submit.prevent>
                                    <div class="search-form__inner">
                                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': workFunctionsInput && workFunctionsInput.length !== 0 }" placeholder="Поиск" v-model.trim="workFunctionsInput" @keydown.enter.prevent.stop>

                                        <button v-if="workFunctionsInput && workFunctionsInput.length !== 0" class="search-form__reset" @click="workFunctionsInput = ''">
                                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                                        </button>

                                        <button class="search-form__submit">
                                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                                        </button>
                                    </div>
                                </form>

                                <draggable class="entry-list entry-list_move"
                                    tag="ul"
                                    v-model="filteredWorkFunctions"
                                    :group="{
                                        name: 'hardSkills',
                                        pull: 'clone',
                                        put: false
                                    }"
                                    :sort="false"
                                >
                                    <li class="entry-list__item" v-for="item in filteredWorkFunctions" :key="item.id">
                                        <div class="entry">
                                            <div class="entry__inner">
                                                <div class="entry__item" v-html="item.name"></div>
                                                <div class="entry__item">
                                                    <div class="entry__actions">
                                                        <div class="entry__actions-item">
                                                            <span class="draggable-btn" @click.stop>
                                                                <icon-base viewBox="0 0 10 14"><icon-draggable /></icon-base>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </draggable>
                            </tab>
                            <tab title="Трудовые действия">
                                <form action="#" class="search-form mb-24">
                                    <div class="search-form__inner">
                                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': workActionsInput && workActionsInput.length !== 0 }" placeholder="Поиск" v-model.trim="workActionsInput" @keydown.enter.prevent.stop>

                                        <button v-if="workActionsInput && workActionsInput.length !== 0" class="search-form__reset" @click="workActionsInput = ''">
                                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                                        </button>

                                        <button class="search-form__submit">
                                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                                        </button>
                                    </div>
                                </form>

                                <draggable class="entry-list"
                                    tag="ul"
                                    v-model="filteredWorkActions"
                                    :group="{
                                        name: 'hardSkills',
                                        pull: 'clone',
                                        put: false
                                    }"
                                    :sort="false"
                                >
                                    <li class="entry-list__item" v-for="item in filteredWorkActions" :key="item.id">
                                        <div class="entry">
                                            <div class="entry__inner">
                                                <div class="entry__item" v-html="item.name"></div>
                                                <div class="entry__item">
                                                    <div class="entry__actions">
                                                        <div class="entry__actions-item">
                                                            <button type="button" class="draggable-btn" @click.stop>
                                                                <icon-base viewBox="0 0 10 14"><icon-draggable /></icon-base>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </draggable>
                            </tab>
                            <tab title="Умения">
                                <form action="#" class="search-form mb-24">
                                    <div class="search-form__inner">
                                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': workSkillsInput && workSkillsInput.length !== 0 }" placeholder="Поиск" v-model.trim="workSkillsInput" @keydown.enter.prevent.stop>

                                        <button v-if="workSkillsInput && workSkillsInput.length !== 0" class="search-form__reset" @click="workSkillsInput = ''">
                                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                                        </button>

                                        <button class="search-form__submit">
                                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                                        </button>
                                    </div>
                                </form>

                                <draggable class="entry-list"
                                    tag="ul"
                                    v-model="filteredWorkSkills"
                                    :group="{
                                        name: 'hardSkills',
                                        pull: 'clone',
                                        put: false
                                    }"
                                    :sort="false"
                                >
                                    <li class="entry-list__item" v-for="item in filteredWorkSkills" :key="item.id">
                                        <div class="entry">
                                            <div class="entry__inner">
                                                <div class="entry__item" v-html="item.name"></div>
                                                <div class="entry__item">
                                                    <div class="entry__actions">
                                                        <div class="entry__actions-item">
                                                            <button type="button" class="draggable-btn" @click.stop>
                                                                <icon-base viewBox="0 0 10 14"><icon-draggable /></icon-base>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </draggable>
                            </tab>
                        </tabs>
                    </div>
                </div>
            </div>
            <div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
                <h2>Добавленные Hard Skills</h2>

                <button type="button" class="btn btn_action-second btn_full" @click.stop="elDialogs.hardSkills = true">
                    Создать или найти Hard Skill

                    <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                </button>

                <draggable class="entry-list mt-12"
                    tag="ul"
                    :group="{
                        name: 'hardSkills',
                        pull: false
                    }"
                    :sort="false"
                    @add="addHardSkill"
                >
                    <li class="entry-list__item" v-for="item in hardSkillsByQualification" :key="item.id">
                        <div class="entry">
                            <div class="entry__inner">
                                <div class="entry__item" v-html="item.name"></div>
                                <div class="entry__item">
                                    <div class="entry__actions">
                                        <div class="entry__actions-item">
                                            <selector-btn :options="accordionHardSkillsOptionsForBtn" :params="{ id: item.id, item: item }" @clickOnItem="callback"></selector-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </draggable>
            </div>
        </div>

        <hard-skills-dialog :qualificationId="qualificationId" />
        <skill-rename-dialog :skillName="addSkillText" :typeSkill="typeSkill" :create="skillCreate" :curItem="renameItem" :qualificationId="qualificationId" v-if="addSkillText && typeSkill" />
        <soft-skills-dialog :qualificationId="qualificationId" />
    </wizard-panel>
</template>

<script>
import Vue from 'vue';
import MaskedInput from 'vue-masked-input';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import draggable from 'vuedraggable';
import { quillEditor } from 'vue-quill-editor'

import { debounce, groupBy } from '@/helpers';
import panel from '@/mixins/panel';

import Accordion from '@/components/Accordion/Accordion';
import AccordionItem from '@/components/Accordion/AccordionItem';
import HardSkillsDialog from '@/components/Dialogs/HardSkillsDialog';
import SkillRenameDialog from '@/components/Dialogs/SkillRenameDialog';
import SoftSkillsDialog from '@/components/Dialogs/SoftSkillsDialog';
import Tab from '@/components/Tabs/Tab';
import Tabs from '@/components/Tabs/Tabs';
import WizardPanel from '@/components/WizardPanels/WizardPanel';
import SelectorBtn from '@/components/SelectorBtn';
import {commit} from "lodash/seq";

let activeCompetence = null;
let competencesLevel = null;

export default {
    mixins: [ panel ],
    props: {
        kindId: {
            required: true,
            type: Number
        },
        qualificationId: {
            required: true,
            type: Number
        },
        read: {
            type: Boolean,
            default: false
        },
    },
    components: {
        Accordion,
        AccordionItem,
        draggable,
        HardSkillsDialog,
        SkillRenameDialog,
        SoftSkillsDialog,
        Tab,
        Tabs,
        WizardPanel,
        SelectorBtn,
        quillEditor
    },
    data() {
        return {
            bus: new Vue(),

            activeSkills: null,
            addSkillText: null,
            typeSkill: null,
            renameItem: null,
            editDescriptors: {},
            searchValue: null,
            workActionsInput: null,
            workFunctionsInput: null,
            workSkillsInput: null,
            skillCreate: false,
            accordionSoftdSkillsOptionsForBtn: [
                {
                    name: 'Переименовать',
                    callback: 'renameSoftSkill'
                },
                {
                    name: 'Удалить',
                    warning: true,
                    callback: 'deleteSoftSkill'
                }
            ],
            accordionHardSkillsOptionsForBtn: [
                {
                    name: 'Переименовать',
                    callback: 'renameHardSkill'
                },
                {
                    name: 'Удалить',
                    warning: true,
                    callback: 'deleteHardSkill'
                }
            ]
        };
    },
    methods: {
        ...mapActions('editor', [
            'CREATE_SOFT_SKILL',
            'LOAD_COMPETENCES',
            'LOAD_SOFT_SKILLS_BY_QUALIFICATION',
            'QUERY_WORK_ACTIONS',
            'GET_WORK_ACTIONS_BY_QUALIFICATION',
            'GET_WORK_SKILLS_BY_QUALIFICATION',
            'LOAD_WORK_FUNCTIONS_BY_QUALIFICATION',
            'QUERY_WORK_FUNCTIONS',
            'QUERY_WORK_SKILLS',
            'UPDATE_SOFT_SKILLS_BY_QUALIFICATION',
            'UPDATE_SOFT_SKILL_BY_QUALIFICATION',
            'DELETE_SOFT_SKILLS_BY_QUALIFICATION',
            'DELETE_HARD_SKILLS_BY_QUALIFICATION',
        ]),
        ...mapMutations('editor', ['SET_QUALIFICATIONS', 'GROUP_QUALIFICATIONS']),
        ...mapMutations('common', ['TOGGLE_ALERT']),

        callback(emitObj) {
            this[emitObj.callback](emitObj.args)
        },

        onmoveTest() {
          if (!competencesLevel) {
            return false;
          }
        },

        async deleteSoftSkill({ id }) {
            const params = {
                id: this.qualificationId,
                ids: [id]
            }
            await this.DELETE_SOFT_SKILLS_BY_QUALIFICATION(params)

            const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
            await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualificationId ? Object.assign(qualification, { soft_skills: this.softSkillsByQualification.length }) : qualification))
            await this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
        },
        async deleteHardSkill({ id }) {
            const params = {
                id: this.qualificationId,
                ids: [id]
            }
            await this.DELETE_HARD_SKILLS_BY_QUALIFICATION(params)

            const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
            await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualificationId ? Object.assign(qualification, { hard_skills: this.hardSkillsByQualification.length }) : qualification))
            await this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
        },

        addHardSkill(e) {
            if (e.item) this.addSkillText = e.item.innerText;
            this.typeSkill = 'Hard Skill';
            this.skillCreate = true
            
            this.elDialogs.skillRename = true;
        },
        async addSoftSkill(obj) {
            console.log(activeCompetence);
            const newSoftSkill = await this.CREATE_SOFT_SKILL(activeCompetence);
            const ids = [...this.softSkillsByQualification.map((item) => item.id), newSoftSkill.id];

            await this.UPDATE_SOFT_SKILLS_BY_QUALIFICATION({
                id: this.qualificationId,
                ids
            });

            await this.LOAD_SOFT_SKILLS_BY_QUALIFICATION(this.qualificationId);

            const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
            await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualificationId ? Object.assign(qualification, { soft_skills: this.softSkillsByQualification.length }) : qualification))
            await this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
        },

        renameHardSkill({ item }) {
            this.addSkillText = item.name;
            this.typeSkill = 'Hard Skill';
            this.skillCreate = false
            this.renameItem = item
            
            this.elDialogs.skillRename = true;
        },
        renameSoftSkill({ item }) {
            this.addSkillText = item.name;
            this.typeSkill = 'Soft Skill';
            this.skillCreate = false
            this.renameItem = item
            
            this.elDialogs.skillRename = true;
        },

        cloneSoftSkill(competence) {
            console.log(competence);
            console.log(competencesLevel);

            if (!competencesLevel) {
              this.TOGGLE_ALERT({open:true, status: 'warning', text: 'Раскройте компетенцию и выберите уровень', timer: 0});
              return;
            }


            activeCompetence = competence.find((item) => item.level === competencesLevel);


            return activeCompetence;
        },
        async openSkills(skillName) {
            this.elPanels.competences = 2;
            this.activeSkills = skillName;
            this.$emit('changeActiveSkills', skillName)

            if (this.activeSkills === 'hardSkills') {
                await Promise.all([
                    this.GET_WORK_ACTIONS_BY_QUALIFICATION(this.qualificationId),
                    this.GET_WORK_SKILLS_BY_QUALIFICATION(this.qualificationId),
                    this.LOAD_WORK_FUNCTIONS_BY_QUALIFICATION(this.qualificationId)
                ]);
            }
        },

        search(category) {
            // Поиск по категориям
            const settings = {
                workActions: {
                    model: this.workActionsInput,
                    query: 'QUERY_WORK_ACTIONS'
                },
                workFunctions: {
                    model: this.workFunctionsInput,
                    query: 'QUERY_WORK_FUNCTIONS'
                },
                workSkills: {
                    model: this.workSkillsInput,
                    query: 'QUERY_WORK_SKILLS'
                }
            }

            this[settings[category].query](settings[category].model);
        },
        startHandler(i) {
            competencesLevel = i + 1;
        },
        toggleEditMode(id) {
            this.$set(this.editDescriptors, id, !this.editDescriptors[id] ? true : false);
            console.log(this.editDescriptors);
        },
        async updateSoftSkill(item) {
            await this.UPDATE_SOFT_SKILL_BY_QUALIFICATION(item);

            this.$set(this.editDescriptors, item.id, false);
        }
    },
    computed: {
        ...mapGetters('editor', ['GET_KIND_BY_ID']),
        ...mapState('common', ['panels']),
        ...mapState('editor', ['competences', 'hardSkillsByQualification', 'softSkillsByQualification', 'workActions', 'workFunctions', 'workSkills', 'standard', 'qualifications', 'groupItemsBy']),
        competencesData() {
            if (!this.searchValue) {
                return this.competences;
            }

            const filteredCompetences = {};

            for (const key in this.competences) {
                if (key.toLowerCase().includes(this.searchValue.toLowerCase())) {
                    filteredCompetences[key] = this.competences[key];
                }
            }

            return filteredCompetences;
        },
        input: {
            get() {
                return this.searchValue;
            },
            set: debounce(function(val) {
                this.searchValue = val;
            }, 30)
        },
        kindName() {
            return this.GET_KIND_BY_ID(this.kindId).name;
        },
        softSkills() {
            return JSON.parse(JSON.stringify(this.softSkillsByQualification));
        },
        filteredWorkFunctions() {
            return this.workFunctionsInput ? this.workFunctions.filter((item) => item.name.toLowerCase().includes(this.workFunctionsInput.toLowerCase())) : this.workFunctions
        },
        filteredWorkActions() {
            return this.workActionsInput ? this.workActions.filter((item) => item.name.toLowerCase().includes(this.workActionsInput.toLowerCase())) : this.workActions
        },
        filteredWorkSkills() {
            return this.workSkillsInput ? this.workSkills.filter((item) => item.name.toLowerCase().includes(this.workSkillsInput.toLowerCase())) : this.workSkills
        },
    }
}
</script>
